import React from 'react';
import {UserContext} from '../../../utils/usercontext';
import {postApi, putApi, dateLocalUTC, consoleLog} from '../../../utils/functions';

import moment from 'moment';
//import { DateTime } from 'luxon';
import { DatePicker } from "antd";
import dayjs from 'dayjs';
//import "antd/dist/antd.css";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
//import BBCode from '../../components/bbcode/bbcode';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import Palette from '../colour/palette';
//import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import { createReactEditorJS } from 'react-editor-js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Pagination from 'react-bootstrap/Pagination';
import Tooltip from 'react-bootstrap/Tooltip';

import './organiser.css';

const ReactEditorJS = createReactEditorJS();

export default class OrganiserEdit extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);

		//consoleLog(typeof this.props.organiser.start, this.props.organiser.start);
    this.state = {
			show: this.props.show ? true : false,
			service: this.props.service,

			id: 0,
			oid: 0,
			showname: '',
			description: '',
			length: 60,
			recurring: 0,
			date: dayjs(this.props.date),
			start: new Date(this.props.date),
			end: new Date(this.props.date),
			timezone: this.props.timezone,

			genres: {
        show: false, // to show selection
        value: '', // searching
        fulllist: [], // full list of genres
        picker: {}, // selected genres
        picked: []
      },
			
			

			colour: `#ffffff99`,
    };
		//consoleLog(this.props.organiser);
		this.editorInstance = React.createRef();
		this.close = this.close.bind(this);
		this.handleChange = this.handleChange.bind(this);
		//this.handleTimezone = this.handleTimezone.bind(this);
		this.handleLength = this.handleLength.bind(this);
		this.submitEvent = this.submitEvent.bind(this);
		this.setDate = this.setDate.bind(this);
		this.setStart = this.setStart.bind(this);
		this.setEnd = this.setEnd.bind(this);
		this.selectGenre = this.selectGenre.bind(this);
		this.removeGenre = this.removeGenre.bind(this);
		this.setColourpalette = this.setColourpalette.bind(this);
  };

  async componentDidMount() {
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.props.service);
		const x = await postApi(`${value.worker[this.props.service]}/v3/service/prepare`, params);
		if( x.status === 200 ) {
			let genres = this.state.genres;
      genres.fulllist = x.data.genres;
      this.setState({genres});
		}
	}

	close() {
		this.setState({ show: false });
		this.props.close();
	}


	handleChange(event) {
		let item = event.target.value;
		if( event.target.name === "showname" ) this.setState({showname: item});
		//if( event.target.name === "description" ) this.setState({description: item});
		if( event.target.name === "recurring" ) this.setState({recurring: parseInt(item)});
		if( event.target.name === "genre" ) {
      let genres = this.state.genres;
      genres.value = item;
      let _new = {};
      if( item.length >= 4 ) {
        genres.show = true;
        for( let i in this.state.genres.fulllist ) {
          for( let j in this.state.genres.fulllist[i] ) {
            let search = new RegExp(`(${item.replace(' ','|')})`,"gi");
            if( this.state.genres.fulllist[i][j].match(search) != null ) {
              if( !_new[i] ) _new[i] = [];
              _new[i].push(this.state.genres.fulllist[i][j]);
            }
          }
        }
      } else genres.show = false;
      genres.picker = _new;
      this.setState({genres});
    }
	}

	/*handleTimezone(timezone) {
		this.setState({timezone: timezone.value});
	}*/

	handleLength(minutes) {
		this.setState({length: minutes});
	}

	
	setDate(e) {
		let date = this.state.date;
		if( e ) {
			date = e._d || e['$d'];
		} else {
			date = 0;
		}
		this.setState({date});
	}

	setStart(e) {
		this.setState({start: e._d});
	}

	setEnd(e) {
		this.setState({end: e._d});
	}

	async submitEvent(e) {
		e.preventDefault();

		let params = new URLSearchParams();
		params.append('service', this.state.service);
		//if( this.state.id !== 0 )
		params.append(this.state.oid?'eid':'oid', this.state.id);
		params.append('showname', this.state.showname);
		//params.append('description', this.state.description);

		const outputData = await this.editorInstance.current.save();
    params.append('description', JSON.stringify(outputData.blocks));

		params.append('length', this.state.length);
		params.append('recurring', this.state.recurring);

		let c = dateLocalUTC(this.state.date);
		let d = dateLocalUTC(this.state.start);
		let f = dateLocalUTC(this.state.end);
		params.append('date', Math.floor( c.getTime() / 1000 ));
		params.append('start', Math.floor( d.getTime() / 1000 ));
		params.append('end', Math.floor( f.getTime() / 1000 ));

		params.append('genres', this.state.genres.picked.join(','));
		params.append('color', this.state.colour);
		//params.append('timezone', this.state.timezone);

		const x = await putApi(`${this.context.worker[this.props.service]}/v3/admin/organiser`, params); 

		if( x.status === 200 ) this.close();
	}

	selectGenre(genre) {
    let genres = this.state.genres;
    genres.show = false;
    genres.value = '';
		for( let i in genres.picker ) if( genre === genres.picker[i] ) return;
		genres.picked.push(genre);
		this.setState({genres});
	}

	removeGenre(genre) {
		let genres = this.state.genres;
		for( let i in genres.picked ) if( genre === genres.picked[i] ) genres.picked.splice( i, 1 );
		this.setState({genres});
	}


	async setColourpalette(e) {
		let hex = e.hex;
		switch(hex.length) {
			case 7:
				hex = hex + '99';
			break;
			case 9:
				try{
					//hex[6] = hex[7] = 'b';
					hex = e.hex.substring(0,7) + '99';
				} catch(error) {}
			break;
			default:
			break;
		}
		this.setState({colour: hex});
	}


	render() {
		const genrelist = Object.keys(this.state.genres.picker).map((e,i) => {
      return (
        <React.Fragment key={i}>
          <div><p>{e}</p></div>
          <div style={{marginLeft: -5}}>
            {(() => {
              return Object.keys(this.state.genres.picker[e]).map((f,j) => {
                return (
                  <Button key={j} className="btn btn-sm btn-info my-1 me-2" onClick={()=>this.selectGenre(this.state.genres.picker[e][f])}>{this.state.genres.picker[e][f]}</Button>
                )
              })
            })()}
          </div>
          <div style={{clear: 'both', paddingBottom: 10}}></div>
        </React.Fragment>
      )
    })
    const genrepicked = this.state.genres.picked.map((e,i) => {
      return (
        <Button key={i} size="sm" className="btn btn-teal-gradient btn-wave waves-effect waves-light">{e}
          <OverlayTrigger placement="top" key="overlay-5" overlay={<Tooltip id="tooltip5">Remove Genre</Tooltip>}>
            <span className="badge ms-2 bg-white text-primary" onClick={()=>this.removeGenre(e)}><FontAwesomeIcon icon="xmark" /></span>
          </OverlayTrigger>
          
        </Button>
      )
    })
		return (
				
			<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
				<Modal.Header closeButton className="">
					<Modal.Title>Create Event</Modal.Title>
				</Modal.Header>
				<Modal.Body className="">
					<Row>
						<Col xs={12}>
							<Form onSubmit={this.submitEvent}>
							
								{/*this.props.organiser.isOwner === true &&
									<>
										<div className="form-group row pt-2 mb-1">
											<label htmlFor="timezone" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vleft">
												<strong>Timezone</strong><br />
											</label>
											<div className="col-md-6">
												<TimezoneSelect
													value={this.state.timezone}
													onChange={this.handleTimezone}
													labelStyle='abbrev'
													timezones={{
														...allTimezones
														//'America/Lima': 'Pittsburgh',
														//'Europe/Berlin': 'Frankfurt',
													}}
												/>
												
											</div>
										</div>

										

										<hr style={{borderColor: '#aaaaaa'}} />
									</>
								*/}

								<div className="form-group row pt-2 mb-1">
									
									<div className="col">
										Please use the following fields to outline the days schedule event, for example, Fryday Funday, Trance range 120 bpm to 140 bpm.
									</div>
								</div>
								
								<div className="form-group row pt-2 mb-1">
									<label htmlFor="showname" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vleft">
										<strong>Show Name</strong><br />
									</label>
									<div className="col-md-6">
										<Form.Control type="text" name="showname" id="showname" onChange={this.handleChange} value={this.state.showname} className="" placeholder="Show Name" />
										
									</div>
								</div>
							
								<div className="form-group row mb-2">
									<label htmlFor="description" className="col-sm-4 col-form-label col-form-label-sm ps-4">
										<strong>Description</strong>
									</label>
									<div className="col-md-6 text-vleft">
										<div className="form-control form-control-sm">
											<ReactEditorJS
												/*tools={Raw}*/
												onInitialize={instance => (this.editorInstance.current = instance)}
												data={{blocks: (this.state.description?this.state.description:[])}}
											/>
										</div>
									</div>
								</div>

								<div className="form-group row mb-3">
									<label className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vleft">
										<strong>Recurring</strong><br />
										{/*<small>(Repeat event on weekly basis)</small>*/}
									</label>
									<div className="col-md-6">
										{/*<Form.Control type="checkbox" name="recurring" id="recurring" onChange={this.handleChange} className=""/>*/}
										<Form.Control size="sm" as="select" name="recurring" id="recurring" onChange={this.handleChange} value={this.state.recurring}>
											<option value={0}>No Recurring - End Show</option>
											<option value={1}>Weekly</option>
											<option value={2}>Fortnightly</option>
											<option value={3}>Four Weekly</option>
											<option value={4}>Monthly</option>
										</Form.Control>
									</div>
								</div>

								<div className="form-group row">
									<label htmlFor="genres" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vleft">
										<strong>Genres</strong><br />
									</label>
									<div className="col-md-6" style={{position: 'relative'}}>
										<Form.Control type="text" name="genre" id="genre" value={this.state.genres.value} onChange={this.handleChange} className="form-control" placeholder="Search Genres" />
										{this.state.genres.show === true &&
											<div className="card card-body p-1" style={{position: 'absolute', top: 33, width: '96%', fontSize: 14, maxHeight: 245, overflowY: 'scroll', zIndex:5}}>
												<div className="blockquote custom-blockquote info mb-0" style={{padding: 10}}>
													{genrelist}
												</div>
											</div>
										}
										<div className="col">
											<div className="genrepick-box">
												{genrepicked}
											</div>
										</div>
									</div>
								</div>

								<hr style={{borderColor: '#aaaaaa'}} />


								<div className="form-group row">
									<label className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vleft">
										<strong>Date for next recurring event</strong><br />
										{/*<small>Timezone {DateTime.local().toFormat('ZZZZ')}</small><br />*/}
										<strong className="schedule_error">{this.state.err_start}</strong>
									</label>
									<div className="col">
										<Row className="gx-0 pb-2">
											<Col xs={4}>
												Date
											</Col>
											<Col xs={4}>
												Start Time
											</Col>
											<Col xs={4}>
												End Time
											</Col>
											<Col xs={4}>
												<DatePicker defaultValue={this.state.date} onChange={this.setDate} getPopupContainer={(triggerNode)=>{return triggerNode.parentNode;}} onFocus={e => e.target.blur()} />
											</Col>

											<Col xs={4}>
												<TimePicker
													placeholder="Select Time"
													use12Hours={false}
													showSecond={false}
													focusOnOpen={true}
													minuteStep={30}
													format="HH:mm"
													defaultValue={moment(this.state.start)}
													onChange={(e)=>this.setStart(e)}
													popupClassName="text-oppisite"
													onFocus={e => e.target.blur()}
												/>
											</Col>
											<Col xs={4}>
												<TimePicker
													placeholder="Select Time"
													use12Hours={false}
													showSecond={false}
													focusOnOpen={true}
													minuteStep={30}
													format="HH:mm"
													defaultValue={moment(this.state.end)}
													onChange={(e)=>this.setEnd(e)}
													popupClassName="text-oppisite"
													onFocus={e => e.target.blur()}
												/>
											</Col>
										</Row>
									</div>
									{/**/}
								</div>

								<div className="form-group row mb-3">
									<label className="col-sm-4 col-form-label col-form-label-sm ps-4">
										<strong>DJ Running Time</strong><br />
									</label>
									<div className="col-md-6 text-vleft">
										<Pagination size="sm">
											<Pagination.Item active={this.state.length === 60?true:false} onClick={()=>this.handleLength(60)}>60 Minutes</Pagination.Item>
											<Pagination.Item active={this.state.length === 90?true:false} onClick={()=>this.handleLength(90)}>90 Minutes</Pagination.Item>
											<Pagination.Item active={this.state.length === 120?true:false} onClick={()=>this.handleLength(120)}>2 Hours</Pagination.Item>
										</Pagination>
										</div>
								</div>

								<hr style={{borderColor: '#aaaaaa'}} />

								<div className="form-group row">
									<label htmlFor="title" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vleft">
										<strong>Colour</strong>
									</label>
									<div className="col-md-6">
										<div className="" onClick={()=>this.showColour()}></div>

										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic">
												<Palette colour={this.state.colour} newColour={this.setColourpalette} />
											</Popover>
											}>
											<div className="oragniser-colour" style={{backgroundColor: this.state.colour}}></div>
										</OverlayTrigger>
									</div>
								</div>

							</Form>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer className="">
					<Button size="sm" variant="secondary" onClick={this.close}>Close</Button>
					<Button size="sm" variant="primary" onClick={this.submitEvent}>Create Event</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}
